import React from 'react'
import { Typography, Card, CardContent, CardHeader, CardMedia, Grid, Box, CardActions } from '@material-ui/core'
import useCurrentUserEntity from 'hooks/useCurrentUserEntity'
import useCurrentUserProp from 'hooks/useCurrentUserProp'
import PlaidButton from 'components/PlaidButton'

export default function WithdrawalAccount() {
  const hasAccount = useCurrentUserProp('withdrawalAccount')

  return (
    <Card>
      <CardHeader title='Funding Account' />
      {hasAccount ? (
        <NonEmptyState />
      ) : (
        <EmptyState />
      )}
    </Card>
  )
}

function NonEmptyState() {
  const { encodedBankLogo, bankName, depositoryType, mask } = useCurrentUserEntity('withdrawalAccount')

  return (
    <Grid container justifyContent='space-between' alignItems='center' component={Box} p={2}>
      <Grid item maxWidth={'6rem'} component={Box} p={2}>
        <CardMedia component='img' src={`data:image/png;base64, ${encodedBankLogo}`} />
      </Grid>

      <Grid item>
        <CardContent>
          <Typography variant='h6'>{bankName}</Typography>
          <Typography variant='subtitle1'>{`${depositoryType} •••••••••${mask}`}</Typography>
        </CardContent>
      </Grid>
    </Grid>
  )
}

function EmptyState() {
  return (
    <React.Fragment>
      <CardContent>
        <Typography variant='subtitle1' align='center'>
          No funding source added yet
        </Typography>
      </CardContent>

      <CardActions>
        <PlaidButton includeWithdrawalAccount fullWidth size='large' color='secondary' variant='contained'>
          Connect Funding Source
        </PlaidButton>
      </CardActions>
    </React.Fragment>
  )
}
